import Nav from "../components/Nav"
import Footer from "../components/Footer"
import Container from "../components/core/Container"
import SectionTag from "../components/core/SectionTag"
import { nabidka } from "../courses/nabidka"
import { lecturers } from "../lecturers/lecturers"
import Paragraph from "../components/core/Paragraph"
import { useSearchParams } from "react-router-dom"
import { useEffect } from "react"
import { useState } from "react"
import Heading from "../components/core/Heading"
import RegistrationForm from "../components/form/RegistrationForm"
import { sendRegistrationEmail } from "../api/send/application"
import { sendRegistrationNotifyEmail } from "../api/send/application_notify"
import { handleSubscribeUsSubmit } from "../handlers/handleSubcribeUsSubmit"
import SEO from "../components/SEO"
import { useNavigate } from "react-router";
import InfoPopUp from "../components/pop_up/InfoPopUp"


export default function PrihlaseniKurzPage() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [entity, setEntity] = useState(null)
    const [lecturer, setLecturer] = useState(null)
    const [isInfoPopUpOpen, setIsInfoPopUpOpen] = useState(false);
    const [infoPopUpTitle, setInfoPopUpTitle] = useState("");
    const [infoPopUpText, setInfoPopUpText] = useState("");
    const [infoPopUpType, setInfoPopUpType] = useState("success");
    const navigate = useNavigate();

    const handleBackToKurzyPage = () => {
        navigate('/kurzy');
    }

    useEffect(() => {
        if (id) {
            const foundEntity = nabidka.find(course => course.id === parseInt(id));
            console.log('Found entity:', foundEntity);
            if (foundEntity) {
                setEntity(foundEntity);
                const foundLecturer = lecturers.find(lec => lec.id === foundEntity.lecturer);
                console.log('Found lecturer:', foundLecturer, 'Looking for:', foundEntity.lecturer);
                if (foundLecturer) {
                    setLecturer(foundLecturer);
                } else {
                    console.error('Lecturer not found for:', foundEntity.lecturer);
                }
            } else {
                console.error('Entity not found for id:', id);
            }
        }
    }, [id])

    if (!entity || !lecturer){
        return(
            <Container>
                <Paragraph>Nepovedlo se načíst kurz nebo lektora</Paragraph>
            </Container>
        )
    }

    // logika pro odeslání formuláře - registrace na kurz
    const handleRegistrationSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            // Informace o kurzu
            course_id: entity.id,
            course: entity.name,
            course_description: entity.description,
            realization_date: entity.realization_date,
            format: entity.format,
            location: entity.location,
            live_price: entity.live_price,
            is_available: entity.is_available,
            thumbnail: entity.thumbnail,
            // Informace o lektorovi
            lecturer: lecturer.name,
            lecturer_id: entity.lecturer,
            // Informace o účastníkovi
            senderName: e.target.name.value,
            senderSurname: e.target.surname.value,
            birthDate: e.target.birthdate.value,
            company: e.target.company.value,
            ico_rez: e.target.ico_rez.value,
            address: e.target.address.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            message: e.target.message.value,
            payment: e.target.platba.value,
            newsletter: e.target.newsletter?.checked ?? false
        };
        console.log(formData);
        
        try {
            await sendRegistrationEmail(formData);
            // Odeslání potvrzení přihlášenému
            try {
                await sendRegistrationNotifyEmail(formData);
                // Pokud chce odebírat newsletter
                if (formData.newsletter) {
                    try {
                        await handleSubscribeUsSubmit({ email: formData.email });
                    } catch (newsletterErr) {
                        console.warn('Newsletter subscribe failed (registrace proběhla):', newsletterErr);
                    }
                }

            } catch (notifyError) {
                console.error('Chyba při odesílání potvrzení:', notifyError);
                // I když se potvrzení nepodařilo odeslat, registrace byla úspěšná
            }
            
            // Zobrazení úspěšné zprávy
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("success");
            setInfoPopUpTitle("Registrace byla úspěšně odeslána!");
            setInfoPopUpText("Vaše registrace na kurz byla úspěšně odeslána! Na zadanou e-mailovou adresu Vám bude zasláno potvrzení o přihlášení. Následně dojde ke zpracování Vaší přihlášky a v průběhu několika dní Vám bude na e-mail zaslána faktura.");
            
            // Reset formuláře po úspěšném odeslání
            e.target.reset();
        } catch (error) {
            console.error('Chyba při odesílání:', error);
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("error");
            setInfoPopUpTitle("Nepodařilo se odeslat registraci!");
            setInfoPopUpText("Nepodařilo se odeslat registraci. Zkuste to prosím znovu nebo nás kontaktujte přímo.");
        }
    }

    // Handler pro zavření popupu s možností přesměrování
    const handleClosePopUp = () => {
        setIsInfoPopUpOpen(false);
        // Pokud byla registrace úspěšná, přesměruj na stránku kurzů
        if (infoPopUpType === "success") {
            setTimeout(() => {
                handleBackToKurzyPage();
            }, 300); // Malé zpoždění pro plynulý přechod
        }
    }

    return (
        <>
            <SEO
                title={`Přihlášení na kurz: ${entity?.name || 'Kurz'} - digibezstresu`}
                description={entity ? `Přihlaste se na kurz ${entity.name}. ${entity.description.substring(0, 100)}...` : "Přihlášení na vzdělávací kurz"}
                keywords={entity ? `${entity.name}, přihlášení na kurz, registrace, ${entity.format} kurz` : "přihlášení na kurz, registrace"}
                url={`/prihlaseni_kurz?id=${id || ''}`}
            />
            <Container className="min-h-screen flex flex-col relative">
                {/* Obsah stránky */}
                <Container className="relative z-10">
                    <Nav/>
            <Container className="mt-8 mb-8" bgColor="transparent"/>
            <Container className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" bgColor="transparent">
                <SectionTag>
                    Přihlášení na kurz
                </SectionTag>

                {/* Info o kurzu (zkratka kurzu a lektoru) */}
                <Container bgColor="transparent" className="p-4 shadow-md rounded-lg border-2 mb-8">
                    <Heading variant="h2">📩 {entity.name}</Heading>
                    <Container bgColor="main" className="w-full p-1 rounded-lg mt-2 mb-2"/>
                    <Paragraph variant="lead_black">Datum konání: {entity.realization_date}</Paragraph>
                    <Paragraph variant="lead_black">Lektor: {lecturer.name} {lecturer.surname}</Paragraph>
                    <Paragraph variant="lead_black">Formát: {entity.format}</Paragraph>
                    <Paragraph variant="lead_black">Místo konání: {entity.location}</Paragraph>
                    <Paragraph variant="lead_black_bold">Anotace:</Paragraph>
                    <Paragraph variant="lead_black">{entity.description}</Paragraph>
                    <Paragraph variant="lead_black"><span className="font-bold text-main">Cena:</span> {entity.live_price} Kč</Paragraph>
                    <Container bgColor="main" className="w-full p-1 rounded-lg mt-2 mb-2"/>
                </Container>

                <Container bgColor="transparent" className="p-4 shadow-md rounded-lg border-2 mb-8">
                    <Heading variant="h2">🧑‍🏫 Další instrukce</Heading>
                    <span className="block text-gray-600 text-sm leading-relaxed text-justify">
                        Na níže zadanou e-mailovou adresu Vám bude zasláno potvrzení o přihlášení na kurz. Následně dojde ke zpracování Vaší přihlášky a v průběhu několika dní Vám bude na e-mail zaslána faktura. Po jejím zaplacení Vám bude zhruba den až dva před konáním kurzu zaslán odkaz k připojení nebo pozvánka na akci.
                    </span>
                </Container>

                <Container bgColor="main_light" className="mt-10 mb-8 flex flex-col justify-center w-full py-6 px-2 rounded-lg text-center">
                    <Heading variant="h2" color="white">
                    💰 Naše webináře a kurzy je možné hradit z OP JAK II. (šablony) a ONIV 💰
                    </Heading>
                    <Paragraph variant="small_white_bold">
                        Pokud máte zájem o tuto službu, tak nás informujte v poznámce přihlášky.
                    </Paragraph>

                </Container>

                {/* Formulář pro registraci */}
                <RegistrationForm handleRegistrationSubmit={handleRegistrationSubmit}/>
            </Container>
            <Footer/>
        </Container>
            {/* InfoPopUp */}
            {isInfoPopUpOpen && (
                <InfoPopUp 
                    title={infoPopUpTitle} 
                    text={infoPopUpText} 
                    type={infoPopUpType} 
                    onClick={handleClosePopUp}
                />
            )}
    </Container>
    </>
    )
}